module.exports = __webpack_public_path__ + "media/src/ui/images/iconPen-e7cbe4c36167e58fea5352d43797bfa7.png";